import BusinessNotification from './BusinessNotification.jsx';

export {
  BusinessNotification
}


// WEBPACK FOOTER //
// ./components/my-business/sub-view/the-news/notification/index.js